require('./hirePromotionView.scss');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
// @ actions
const promotionsAction = require('actions/promotions');
const profileActions = require('actions/profile');
const preContractualMailActions = require('actions/contactCenter/preContractualMailInfo/preContractualMailInfo');
// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
// @ components
const { CallMeBack } = require('components/callMeBack/callMeBack');
const HirePromotion = require('components/promotions/hirePromotion/hirePromotion');
const HirePromotionSuccess = require('components/promotions/hirePromotionSuccess/hirePromotionSuccess');
const HirePromotionError = require('components/promotions/hirePromotionError/hirePromotionError');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
// @helpers
const { formatText } = require('core/i18n').i18n;
// utilities
const { recordProcess, PROC_HIRE_PROMOTIONS, PROC_START  } = require('utilities/tagging');
// constants
const { getPublicSiteUrl } = require('core/apiURLBuilder');
const { getLanguage} = require('core/i18n').i18n;

class HirePromotionView extends React.Component {
    constructor(props) {
        super(props);

        const code = new URLSearchParams(props.location.search).get('codigo');

        this.state = {
            key: 0,
            promotionalCode: props.location.search && code ? code : '',
        };

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleConfirmLeave = this.handleConfirmLeave.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleGetPromotion = this.handleGetPromotion.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.isReady = this.isReady.bind(this);
    }

    componentDidMount() {
        const { promotionalCode } = this.state;
        recordProcess(PROC_HIRE_PROMOTIONS, PROC_START);

        if (promotionalCode)
            this.handleGetPromotion(promotionalCode);
    }

    componentWillUnmount() {
        if(__CONTACT_CENTER__) {
            const { cancelPromotionalCode } = this.props;
            cancelPromotionalCode();
        }
    }

    buildContent(){
        const {
            immProfileFields,
            immPromotions,
            cancelPromotionalCode,
            immPrecontractualMail,
            requestProfile,
            sendPreContractualMail,
            resetPrecontractualMail
        } = this.props
        const { promotionalCode } = this.state;

        let dataToRender = (
            <div className="row no-outside-gutter">
                <div className="col-xs-8">
                    <WebappRender>
                        <HirePromotion
                            cancelPromotionalCode={cancelPromotionalCode}
                            immPrecontractualMail={immPrecontractualMail}
                            immProfileFields={immProfileFields}
                            immPromotions={immPromotions}
                            onCancel={this.handleCancel}
                            onChange={this.handleInputChange}
                            onFinish={this.handleFinish}
                            onGetPromotion={this.handleGetPromotion}
                            requestProfile={requestProfile}
                            resetPrecontractualMail={resetPrecontractualMail}
                            sendPreContractualMail={sendPreContractualMail}
                            valueInput={promotionalCode}
                        />
                    </WebappRender>
                    <ContactCenterRender>
                        <HirePromotion
                            immPromotions={immPromotions}
                            onCancel={this.handleCancel}
                            onChange={this.handleInputChange}
                            onGetPromotion={this.handleGetPromotion}
                            onFinish={this.handleFinish}
                            cancelPromotionalCode={cancelPromotionalCode}
                            immProfileFields={immProfileFields}
                            immPrecontractualMail={immPrecontractualMail}
                            requestProfile={requestProfile}
                            resetPrecontractualMail={resetPrecontractualMail}
                            sendPreContractualMail={sendPreContractualMail}
                        />
                    </ContactCenterRender>
                </div>
                <div className="col-xs-4">
                    <CallMeBack pageTitle={formatText('promotions-titleHeaderView')} hasEntrance={false} />
                </div>
            </div>
        );

        if (!immPromotions.get('isPromotionAlreadyHired')) {
            if (immPromotions.get('setPromotionSuccessful')) {
                const immPromotion = immPromotions.getIn(['byId', promotionalCode]);
                dataToRender = (
                    <HirePromotionSuccess immProfileFields={immProfileFields}
                        immPromotion={immPromotion}
                    />
                );
            } else if (immPromotions.get('settingPromotionError') !== '') {
                dataToRender = <HirePromotionError />;
            }
        }

        return dataToRender;
    }

    handleCancel() {
        const { history, resetPrecontractualMail } = this.props;

        if (__CONTACT_CENTER__) {
            resetPrecontractualMail();
            history.push('/myprofile/global');
        } else {
            const publicPromotionsPath = getLanguage().toLowerCase() === 'es' ? '/ofertas-bancarias' : '/en/bank-promotions';
            const publicPromotionsLink = `${getPublicSiteUrl()}${publicPromotionsPath}`;
            if (this.isReady()) {
                window.location.href = publicPromotionsLink;
            } else {
                window.modalInstance.routerWillLeave({ externalLink: publicPromotionsLink });
            }
        }
    }

    handleConfirmLeave() {
        const {
            cancelHirePromotion,
            cancelPromotionalCode,
        } = this.props;

        cancelPromotionalCode();
        cancelHirePromotion();

        this.setState(prevState => ({
                key: prevState.key + 1,
                promotionalCode: '',
            })
        );
    }

    handleFinish(promotionalCode) {
        this.setState({
            promotionalCode
        });
        this.props.setPromotion(promotionalCode, true);
    }

    handleGetPromotion(promotionalCode) {
        this.props.requestPromotion(promotionalCode);
    }

    handleInputChange(promotionalCode) {
        this.setState({
            promotionalCode
        });
    }

    isReady() {
        const { immPromotions } = this.props;
        const { promotionalCode } = this.state;
        const immPromotion = immPromotions.getIn(['byId', promotionalCode]);

        return promotionalCode === '' ||
            immPromotions.get('settingPromotionError') !== '' ||
            (!!immPromotion && !!immPromotion.get('claimedId'));
    }

    render() {
        const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
        const cancelText = formatText('wizard-redirectConfirmationCancelButton');
        const confirmationTitle = formatText('wizard-redirectConfirmationTitle');
        const confirmationMessage = formatText('wizard-redirectConfirmationMessage');
        const titleHeader = formatText('promotions-titleHeaderView');
        const content = this.buildContent();

        return (
            <section
                className="hire-promotion-view"
                key={this.state.key}
            >
                <OKCover size="small" section="pg">
                    <OKHeaderLanding title={titleHeader}/>
                </OKCover>
                <section className="hire-promotion-view__body">
                    {content}
                </section>
                <PreLeaveModalComponent
                    confirmationMessage={confirmationMessage}
                    confirmationTitle={confirmationTitle}
                    acceptText={acceptText}
                    cancelText={cancelText}
                    isReady={this.isReady}
                    onConfirmLeave={this.handleConfirmLeave}
                />
            </section>
        );
    }
}

HirePromotionView.propTypes =  {
    cancelHirePromotion: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immPrecontractualMail: PropTypes.object.isRequired,
    immPromotions: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
    requestPromotion: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    setPromotion: PropTypes.func.isRequired,
    cancelPromotionalCode : PropTypes.func.isRequired,
    location: PropTypes.object,
};
module.exports.constructor = HirePromotionView;
module.exports.HirePromotionView = connect(
    state => ({
        immPrecontractualMail: state.preContractualMail,
        immProfileFields: state.profile,
        immPromotions: state.promotions
    }), {
        cancelHirePromotion: promotionsAction.cancelHirePromotion,
        requestProfile: profileActions.requestProfile,
        requestPromotion: promotionsAction.requestPromotion,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        sendPreContractualMail: preContractualMailActions.sendPromotionPrecontractualMail,
        setPromotion: promotionsAction.setPromotion,
        cancelPromotionalCode: promotionsAction.cancelPromotionalCode
    }
)(withRouter(HirePromotionView));
